import React from "react";
import ReactVortoxSpinner from "./ReactVortoxSpinner";

const SearchBar = ({
  searchFilterApplied,
  searchString,
  onChangeSearch,
  onClickSearch,
  handleKeyPress,
  loading,
}) => {
  return (
    <div
      className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
        searchFilterApplied ? "redBorderRedText" : ""
      }`}
    >
      <input
        type="search"
        className="input"
        placeholder="Search..."
        value={searchString}
        onChange={onChangeSearch}
        onKeyDown={handleKeyPress}
      />
      <button type="button" className="button" onClick={() => onClickSearch(searchString)}>
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <>
            search
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </>
        )}
      </button>
    </div>
  );
};

export default SearchBar;
